export default __webpack_public_path__ + "img/4.asset.8b1636dd.jpeg";